module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('b-row', {
    staticClass: "justify-content-center"
  }, [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-card-group', [_c('b-card', {
    staticClass: "p-4",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-body', [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.DoLogin($event)
      }
    }
  }, [_c('h1', [_vm._v("Đăng nhập")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Đăng nhập vào tài khoản của bạn")]), _vm._v(" "), _c('b-input-group', {
    staticClass: "mb-3"
  }, [_c('b-input-group-prepend', [_c('b-input-group-text', [_c('i', {
    staticClass: "icon-user"
  })])], 1), _vm._v(" "), _c('b-form-input', {
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.submitted && _vm.$v.username.$error
    },
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "Email đăng nhập",
      "autocomplete": "username email"
    },
    model: {
      value: (_vm.$v.username.$model),
      callback: function($$v) {
        _vm.$set(_vm.$v.username, "$model", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "$v.username.$model"
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.username.required) ? _c('div', {
    staticClass: "invalid-feedback"
  }, [_vm._v("Bắt buộc\n                                        phải nhập Email\n                                    ")]) : _vm._e()], 1), _vm._v(" "), _c('b-input-group', {
    staticClass: "mb-4"
  }, [_c('b-input-group-prepend', [_c('b-input-group-text', [_c('i', {
    staticClass: "icon-lock"
  })])], 1), _vm._v(" "), _c('b-form-input', {
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.submitted && _vm.$v.password.$error
    },
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Mật khẩu",
      "autocomplete": "current-password"
    },
    model: {
      value: (_vm.$v.password.$model),
      callback: function($$v) {
        _vm.$set(_vm.$v.password, "$model", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "$v.password.$model"
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.password.required) ? _c('div', {
    staticClass: "invalid-feedback"
  }, [_vm._v("Bắt buộc\n                                        phải nhập mật khẩu\n                                    ")]) : _vm._e()], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-button', {
    staticClass: "px-4",
    attrs: {
      "disabled": _vm.loading,
      "variant": "primary"
    },
    on: {
      "click": _vm.DoLogin
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "spinner-border spinner-border-sm"
  }), _vm._v(" "), _c('span', [_vm._v("Đăng nhập")])])], 1)], 1), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-67c5d161", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-67c5d161!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/pages/Login.vue
// module id = 1544
// module chunks = 49